import { withAccountUtm } from "@/utils/account-utm";

const MANAGED_FORMS_UTM = {
  utm_medium: "referral",
  utm_campaign: "student-account",
} as const;

export const MANAGED_FORMS_URL = withAccountUtm(
  "https://www.withmanaged.com/digital-forms",
  {
    ...MANAGED_FORMS_UTM,
    utm_content: "find-out-more",
  },
);

export const MANAGED_FORMS_IOS_URL = withAccountUtm(
  "https://apps.apple.com/gb/app/managed-forms/id6770309101",
  {
    ...MANAGED_FORMS_UTM,
    utm_content: "app-store",
  },
);

export const MANAGED_FORMS_ANDROID_URL = withAccountUtm(
  "https://play.google.com/store/apps/details?id=com.managed.forms",
  {
    ...MANAGED_FORMS_UTM,
    utm_content: "google-play",
  },
);

export const MANAGED_FORMS_ICON_URL = "/images/managed-forms-icon.png";

export const MANAGED_FORMS_APPLE_BADGE_URL = "/images/apple-download.png";

export const MANAGED_FORMS_GOOGLE_BADGE_URL = "/images/google-download.png";
